import * as Sentry from '@sentry/browser'

export const captureException = error => {
  Sentry.captureException(error, {
    tags: { traceId: error?.response?.headers?.['x-amzn-trace-id'] ?? 'no-response-header' },
  })
}

export * from '@sentry/browser'
